module.exports = __webpack_public_path__ + "static/birdHouse2-522a79e2c9f4483c3ae56d2688480038.jpg";